
import React from "react";

interface FAQItemProps {
  question: string;
  children: React.ReactNode;
}

const FAQItem: React.FC<FAQItemProps> = ({ question, children }) => {
  return (
    <div className="mb-6">
      <h3 className="text-lg font-semibold mb-2 text-[#5F436C]">{question}</h3>
      {children}
    </div>
  );
};

export default FAQItem;
